import { handleActions } from 'redux-actions';

import { FETCH_INFO_SWISS_DATA } from '../constants/index';

const initialState = {};

export const infoSwiss = handleActions(
  {
    [FETCH_INFO_SWISS_DATA]: (state, action) => action.payload,
  },
  initialState,
);
